import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findPaytmentList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/due/list?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentPay = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentPay?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2ReceiverAgentPayDownload = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentPay/downloadExcel?` + params,
        method: 'GET'
    })
}
export const immediatePay = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/due/immediatePay?` + params,
        method: 'PUT'
    })
}
export const findPaytmentDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}//joins-invoice-system/v1/due/detail?` + params,
        method: 'GET'
    })
}

export const agentPay = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/receiver/agentPay/${id}?` + params,
        method: 'GET',
    })
}